import { render, staticRenderFns } from "./OrganizationManagement.vue?vue&type=template&id=c245d2ee&scoped=true"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js"
import style0 from "./OrganizationManagement.vue?vue&type=style&index=0&id=c245d2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c245d2ee",
  null
  
)

export default component.exports